import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pluralize } from "../../helpers/general";
import { useBookingQuery } from "../../hooks/bookings/useBookingQuery";
import { general } from "../../locales/general";
import BookingFilters from "../../pages/Bookings/BookingFilters";
import BookingTable from "../../pages/Bookings/BookingTable";
import BoxWrapper from "../ui/BoxWrapper";
import FiltersModel, { FieldConfig } from "../ui/FiltersModel";
import FilterIcon from "../icons/FitlerIcon";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import { BookingSvg } from "../ui/SideBarMenu";

export const BookingTab: React.FC<{ userEmail: string }> = ({ userEmail }) => {
  const { id } = useParams<{ id: string }>();
  const {
    bookings,
    fetchingBookings,
    totalItems,
    currentPage,
    setCurrentPage,
    isPreviousData,
    totalCount,
    setFilters: setBookingFilters,
  } = useBookingQuery();

  const [filters, setFilters] = useState([]);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const bookingsFilter: FieldConfig[] = [
    {
      field: "date",
      type: "date",
      label: "Date de réservation",
      operators: ["$eq", "$gt", "$lt", "$gte", "$lte", "$between"],
    },
  ];

  useEffect(() => {
    setBookingFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <div
      className="p-4 border rounded-4"
      style={{
        background:
          userEmail === "guest-user@venez.ma"
            ? "radial-gradient(ellipse at center, white 0%, #f6b186 100%)"
            : "white",
      }}
    >
      <h2 className="text-xl font-bold mb-4">Réservations</h2>
      <BoxWrapper>
        <FiltersModel
          open={filtersVisible}
          onClose={() => setFiltersVisible(false)}
          configs={bookingsFilter}
          callback={(filters) => {
            setFilters(filters);
          }}
        />
        <div className="d-flex flex-column-reverse flex-md-row  justify-content-end">
          <div className="d-flex align-items-center justify-content-between">
            <div style={{ marginRight: "10px", cursor: "pointer" }}>
              <button
                onClick={() => setFiltersVisible(true)}
                className="outline-none btn btn-outline-danger rounded-pill text-danger d-flex align-items-center gap-2 justify-content-center shadow-primary"
              >
                <FilterIcon />
              </button>
            </div>
            <div
              className="d-flex align-items-center justify-content-center gap-3 bg-gradient-primary p-3 w-100"
              style={{ borderTopRightRadius: "8px" }}
            >
              <BookingSvg className="fill-white" />
              <p className="fs-5 fw-bold m-0  text-white">
                {totalCount} {pluralize("Réservation", totalCount)}
              </p>
            </div>
          </div>
        </div>
        <BookingFilters disableFilters={false} mode="user" userId={id} />

        <RenderTable
          loading={fetchingBookings || isPreviousData}
          render={() =>
            bookings?.length > 0 ? (
              <BookingTable bookings={bookings} />
            ) : (
              <p className="text-center fs-5 my-2">{general.fr.noData}</p>
            )
          }
        />
      </BoxWrapper>
      <Pagination
        currentPage={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        siblingCount={1}
        totalCount={totalItems}
        pageSize={10}
      />
    </div>
  );
};
